<template>
  <div class="card shadow-sm">
    <div class="d-flex w-100 p-3 justify-content-between mt-1 border-bottom position-relative card-title-ido">
      <h5 class="fw-bold text-primary">设备使用时段分布</h5>
      <span  class="card-link point-curser">
        <span class="px-2" :class="{'text-primary':isSeven}" @click="sum7(true)">7天 </span>
        <span class="px-2" :class="{'text-primary':!isSeven}" @click="sum7(false)">30天 </span></span>
    </div>
    <div class="list-box mt-2">
      <!--              数据-->
      <div class="d-flex w-100 p-2 justify-content-between flex-shrink-0 dom-chat-box" ref="chart">

      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, defineExpose, onUnmounted, onBeforeUnmount} from "vue";
import {getListMock} from "@/api/test";
import * as echarts from 'echarts'
const chart = ref()
let mychart = null
let isSeven = ref(true)
let options = {
  color: ['#0F7EF9','#90ca74'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  grid: {
    left: 60,
    right: '4%',
    top: 40,
    bottom: 50,
    // right: '4%',
    // bottom: '3%',
    // containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      axisLabel: {
        show: true,
        textStyle: {
          color: '#000'
        }
      },
      axisLine: {
        show:true,
        onZero:true,
        symbol:"none",
        lineStyle: {
          color: 'rgba(0, 0, 0, 1)',
          width: 1
        }
      },
      boundaryGap: false,
      splitLine: {
        show: false
      },
      axisTick:false,
      data: ["0","1","2","3","4","5","6"],
    }
  ],
  yAxis: [
    {
      type: 'value',
      name: "小时", //坐标名字
      nameLocation: "end",//坐标位置，支持start,end，middle
      axisLabel: {
        show: true,
        textStyle: {
          color: '#000'
        },
        // formatter: '{value} h'
      },
      axisLine: {
        show:true,
        onZero:true,
        lineStyle: {
          color: 'rgba(0, 0, 0, 1)', // color: 'rgba(6, 145, 254, 0.3)',
          width: 1
        }
      },
      axisTick:false,
      splitLine: {
        show: false
      },
    },

  ],
  series: [
    {
      name: '设备使用累计时长',
      type: 'line',
      smooth: true,
      symbol: 'none',
      itemStyle: {
        normal: {
          color: '#fff',
          fontSize: 14,
          lineStyle: {
            width: 3, //折线宽度
            //折线颜色渐变
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: 'rgba(45,105,249,1)'
            },
              {
                offset: 1,
                color: 'rgba(89,205,253,1)'
              }])
          }
        }
      },
      // areaStyle: {
      //   color: 'rgba(46,82,212,0.2)'    //折线区域的背景颜色
      // },
      stack: 'stack',
      data: [100, 200, 3000, 300, 4033, 50, 60]
    }
  ]
};
onMounted(()=>{
  initChat()
  window.addEventListener('resize', onwindowresize, false)
})
onBeforeUnmount(()=>{
  if (mychart != null && mychart.dispose) {
    mychart.dispose();
    mychart = null
  }
})
onUnmounted(()=>{
  window.removeEventListener('resize', onwindowresize)
  if (mychart != null && mychart.dispose) {
    mychart.dispose();
    mychart = null

  }
})
// 改变时间
const sum7 = (seven)=>{
  isSeven.value = seven
}
// 初始化
const initChat =async ()=>{
  mychart = echarts.init(chart.value)
  mychart && mychart.showLoading()
  await getListMock()
  mychart && mychart.hideLoading()
  mychart && mychart.setOption(options)
}

const onwindowresize = ()=>{
  if (mychart) {
    mychart.resize()
  }
}
const resetChatData = (data)=>{
  options.series.data = data
  mychart && mychart.setOption({
    series:{
      data:data
    }
  })
}
defineExpose({
  resetChatData
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/FirstPageListStyle.scss";
</style>
